(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mauj-chrome"] && !Shopify.designMode) return;
  try {
    (()=>{
    const selector='a[data-mauj-checkout]:is(.mauj-button,.mj-button,.mj-buy-direct)';
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let buttons=[],active=null,frame=0,observer;
    const select=()=>{
      frame=0;
      const height=window.innerHeight;
      const visible=motion.matches||document.hidden||document.querySelector('.mauj.is-motion-paused')?[]:buttons.filter(button=>{
        const rect=button.getBoundingClientRect();
        const style=getComputedStyle(button);
        return rect.width>0&&rect.height>0&&rect.top>=8&&rect.bottom<=height-8&&rect.left>=0&&rect.right<=window.innerWidth&&style.visibility!=='hidden'&&Number(style.opacity)>0&&button.getAttribute('aria-busy')!=='true';
      });
      const next=visible.find(button=>!button.closest('.mj-header,.mauj__sticky'))||visible.find(button=>button.closest('.mauj__sticky'))||visible[0]||null;
      if(next===active)return;
      active?.classList.remove('mauj-glow-active');
      active=next;
      active?.classList.add('mauj-glow-active');
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(select);};
    const setup=()=>{
      observer?.disconnect();
      buttons=[...document.querySelectorAll(selector)];
      observer=new IntersectionObserver(schedule,{threshold:[0,1]});
      buttons.forEach(button=>observer.observe(button));
      schedule();
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('pageshow',schedule);
    document.addEventListener('visibilitychange',schedule);
    document.addEventListener('click',event=>{if(event.target.closest('[data-motion-toggle]'))schedule();});
    document.addEventListener('shopify:section:load',setup);
    motion.addEventListener('change',schedule);
  })();

  document.addEventListener('click', (event) => { const link=event.target.closest('a[data-mauj-checkout]'); if(!link || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return; const current=new URLSearchParams(location.search); const target=new URL(link.href,location.origin); ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','discount'].forEach(key=>{if(current.has(key))target.searchParams.set(key,current.get(key));}); link.href=target.href; link.setAttribute('aria-busy','true'); link.setAttribute('aria-label','Abriendo el pago seguro'); });
  window.addEventListener('pageshow',()=>document.querySelectorAll('a[data-mauj-checkout]').forEach(link=>{link.removeAttribute('aria-busy');link.removeAttribute('aria-label');}));

  document.addEventListener('keydown', (event) => { if(event.key === 'Escape') document.querySelectorAll('.mj-mobile[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  document.addEventListener('click', (event) => { document.querySelectorAll('.mj-mobile[open]').forEach(menu => { if(!menu.contains(event.target)) menu.open = false; }); });
  } catch(e) { console.error(e); }
})();

})();
